"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDefaultLogMeta = exports.shouldLog = exports.currentConsolaLevel = exports.getLogLevel = exports.getColor = exports.getConsolaLevel = void 0;

var _consola = require("consola");

var COLORS = {
  fatal: '#c0392b',
  // red
  error: '#c0392b',
  // red
  warn: '#f39c12',
  // yellow
  success: '#2ecc71',
  // green
  info: '#00bcd4' // cyan

};
var DEFAULT_COLOR = '#7f8c8d'; // grey

/**
 * Get the consola level for a type.
 */

var getConsolaLevel = function getConsolaLevel(type) {
  var _consolaTypes$type;

  return (_consolaTypes$type = _consola._types[type]) === null || _consolaTypes$type === void 0 ? void 0 : _consolaTypes$type.level;
};
/**
 * Get the color for a type.
 */


exports.getConsolaLevel = getConsolaLevel;

var getColor = function getColor(type) {
  return COLORS[type] || DEFAULT_COLOR;
};
/**
 * Get the current log level.
 */


exports.getColor = getColor;

var getLogLevel = function getLogLevel() {
  return typeof window !== 'undefined' ? localStorage.logLevel : process.env.LOG_LEVEL;
};
/**
 * Get the current global type as a consola level.
 */


exports.getLogLevel = getLogLevel;

var currentConsolaLevel = function currentConsolaLevel() {
  var currentLevel = getLogLevel();
  var defaultLevel = 'info';
  return getConsolaLevel(currentLevel) || getConsolaLevel(defaultLevel);
};
/**
 * Return true if the given level should be logged, false otherwise.
 */


exports.currentConsolaLevel = currentConsolaLevel;

var shouldLog = function shouldLog(type) {
  return currentConsolaLevel() >= getConsolaLevel(type);
};
/**
 * Get the metadata to attach to all logs for certain reporters.
 */


exports.shouldLog = shouldLog;

var getDefaultLogMeta = function getDefaultLogMeta() {
  var meta = typeof window !== 'undefined' ? {} : process.env.LOG_META;

  try {
    return JSON.parse(meta);
  } catch (err) {
    return {};
  }
};

exports.getDefaultLogMeta = getDefaultLogMeta;